import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Custom__qgiv-tag-solid",
  "use": "Custom__qgiv-tag-solid-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"Custom__qgiv-tag-solid\"><path fill=\"#394146\" fill-rule=\"nonzero\" d=\"M30.034 82.088 4.099 56.153a8.625 8.625 0 0 1 0-12.198L30.034 18.02a8.625 8.625 0 0 1 6.098-2.526h53.843a8.625 8.625 0 0 1 8.625 8.625v51.87a8.625 8.625 0 0 1-8.625 8.625H36.132a8.625 8.625 0 0 1-6.098-2.526Zm-9.49-38.545a8.5 8.5 0 1 0 12.02 12.021 8.5 8.5 0 0 0-12.02-12.02Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol